import { SiteRoute } from '@journeyapps/package-types';
import * as React from 'react';
import { HeroCapabilityRotator } from '../widgets/home/HeroCapabilityRotator';
import { HomeUpdatesWidget } from '../widgets/home/HomeUpdatesWidget';
import { SectionWidget } from '../widgets/layout/SectionWidget';
const oxide = require('../../media/oxide-cloud.png');
const sector = require('../../media/sector-cloud.png');
const cloudcode = require('../../media/stack/cloudcode-tasks.png');
const developers = require('../../media/developers.jpg');
const ai = require('../../media/ai/codex-and-oxide.png');

const img_header = require('../../media/desktop-mockup-devices-apps.png');

export const HomePageContent: React.FC = () => (
  <>
    <SectionWidget
      index={1}
      zoom={false}
      label="Built by developers, for developers"
      image={developers}
      ltr={false}
      shadow={true}
      content={
        <>
          <p>
            Powerful tools, clean abstractions and the freedom to build your way. Start with an integrated platform,
            then extend it with your own packages, services and logic.
          </p>
          <HeroCapabilityRotator />
        </>
      }
    />

    <SectionWidget
      index={2}
      zoom={false}
      label="Build with AI, without giving up real development"
      image={ai}
      shadow={true}
      link={SiteRoute.AI}
      content={`
        JourneyApps Platform gives AI tools a deterministic way to work with real apps through a powerful CLI,
        platform-aware docs access, draft-based collaboration and the full platform stack. That means AI can help build
        real features while developers keep using traditional code, live editing and human review.
        `}
    />

    <SectionWidget
      index={3}
      zoom={false}
      label="Build with serious tools"
      image={oxide}
      ltr={false}
      shadow={true}
      link={SiteRoute.OXIDE}
      content={`
        OXIDE gives developers a powerful web IDE with live editing, full Git support and the flexibility to move fast
        without graduating out of the platform as apps grow in complexity.
        `}
    />
    <SectionWidget
      index={1}
      zoom={false}
      label="Explore and manage your business data"
      image={sector}
      ltr={true}
      shadow={true}
      link={SiteRoute.SECTOR}
      content={`
        Sector gives developers and back-office teams a shared tool for working with live data. Find records, follow
        relationships, make bulk updates, and investigate changes. Work in Sector directly or use the same tools inside OXIDE.
        `}
    />

    <SectionWidget
      index={2}
      zoom={false}
      label="Automate work and connect your systems"
      image={cloudcode}
      ltr={false}
      shadow={true}
      link={SiteRoute.CLOUD_CODE}
      content={`
        CloudCode runs JavaScript or TypeScript tasks on the server. Run scheduled jobs, respond to data changes,
        and expose HTTP endpoints. Build integrations and backend workflows with or without an app interface.
        `}
    />

    <SectionWidget
      label="Scale from quick wins to complex systems"
      image={img_header}
      zoom={false}
      index={3}
      ltr={true}
      link={SiteRoute.CUSTOMERS}
      content={`
        Start with a single workflow, portal or field app, then keep building on the same foundation as your software
        grows into something bigger. JourneyApps is trusted for mission-critical apps in demanding industries where
        performance, reliability and flexibility matter.
        `}
    />

    <HomeUpdatesWidget />
  </>
);
